import { render, staticRenderFns } from "./Artwork.vue?vue&type=template&id=5d171f7a&scoped=true"
import script from "./Artwork.vue?vue&type=script&lang=js"
export * from "./Artwork.vue?vue&type=script&lang=js"
import style0 from "./Artwork.vue?vue&type=style&index=0&id=5d171f7a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d171f7a",
  null
  
)

export default component.exports